var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1006.96 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.48,493.76c136.34,0,246.88-110.52,246.88-246.87S639.82,0,503.48,0s-246.88,110.54-246.88,246.89,110.53,246.87,246.88,246.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.97,795.47l-46-42.57c-230.93-213.62-588.05-211.19-816.06,5.54l-40.55,38.54c-107.41,102.12-35.15,283.03,113.05,283.03h678.13c149.29,0,221.02-183.17,111.43-284.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientesIcon);
export default __webpack_public_path__ + "static/media/ClientesIcon.4354e613627a60f346af5ba9a8e0d653.svg";
export { ForwardRef as ReactComponent };